.container {
  padding: 5px 2px 0px 2px;
  display: flex;
}

.label {
  margin-right: 4px;
  white-space: nowrap;
}
